import * as Effects from 'redux-saga/effects'
import { all, call, put, take } from 'redux-saga/effects'
import { IntegrationAction } from '../../reducers/airbnb/actionNames'
import fetchActionsName, { ActionNames } from '../../utils/FetchActionsName'
import { callFetch } from '../../actions/fetch'
import connectListing from '../../models/Integration/connectListing'
import { getUserLanguage } from '../../reducers/userAccount/selectors/userAccount'
import { fireToastError } from '../../actions/toasts/fireToast'
import { toggleAirbnbSync } from '../../actions/airbnb'

export const mapLangToGoogleTranslate = lang => {
  let l = lang

  switch (lang) {
    case 'pt_BR':
      l = 'pt'
      break
    case 'pt_rBR':
      l = 'pt'
      break
    case 'fil':
      l = 'tl'
      break
    case 'in':
      l = 'id'
      break
    case 'se':
      l = 'sv'
      break
    case 'pl_PL':
      l = 'pl'
      break
    case 'cz':
      l = 'cs'
      break
    case undefined:
      l = 'en'
      break
  }

  return l
}

function* createListing(action) {
  try {
    const actionNames = fetchActionsName(ActionNames.CreateAirbnbIntegration)
    const [{ service }] = yield all([
      take(actionNames.output),
      put(callFetch(actionNames.input, actionNames.output, connectListing)),
    ])

    yield Effects.put({
      type: IntegrationAction.AcceptCreateListing,
      payload: action.payload,
    })

    const lang = yield Effects.select(getUserLanguage)

    yield call(
      service,
      action.payload.id_room,
      action.payload.id_listing,
      action.payload.price_import,
      mapLangToGoogleTranslate(lang),
    )
    yield Effects.put(toggleAirbnbSync(1))
  } catch (e) {
    yield Effects.put({
      type: IntegrationAction.AcceptDeleteListing,
      payload: {
        id_room: action.payload.id_room,
        id_listing: action.payload.id_listing,
      },
    })
    yield Effects.put(fireToastError(e.message))
    console.error(e)
  }
}

export default function*() {
  yield Effects.takeLatest(IntegrationAction.CreateListing, createListing)
}
